import React from "react";

function PromotionAndMarketing({ stroke = "white" }) {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.59379 16.625L16.3438 7.875M11.6503 0.875L14.7443 2.73L18.337 3.04675L19.7493 6.3665L22.4688 8.7325L21.6603 12.25L22.4688 15.7657L19.7493 18.1335L18.337 21.4532L14.7443 21.77L11.6503 23.625L8.55804 21.77L4.96354 21.4532L3.55304 18.1335L0.831787 15.7657L1.64029 12.25L0.831787 8.73425L3.55304 6.3665L4.96354 3.04675L8.55804 2.73L11.6503 0.875ZM10.2188 9.625C10.2188 10.0891 10.0344 10.5342 9.70622 10.8624C9.37803 11.1906 8.93292 11.375 8.46879 11.375C8.00466 11.375 7.55954 11.1906 7.23135 10.8624C6.90316 10.5342 6.71879 10.0891 6.71879 9.625C6.71879 9.16087 6.90316 8.71575 7.23135 8.38756C7.55954 8.05937 8.00466 7.875 8.46879 7.875C8.93292 7.875 9.37803 8.05937 9.70622 8.38756C10.0344 8.71575 10.2188 9.16087 10.2188 9.625ZM17.2188 15.75C17.2188 16.2141 17.0344 16.6592 16.7062 16.9874C16.378 17.3156 15.9329 17.5 15.4688 17.5C15.0047 17.5 14.5595 17.3156 14.2314 16.9874C13.9032 16.6592 13.7188 16.2141 13.7188 15.75C13.7188 15.2859 13.9032 14.8408 14.2314 14.5126C14.5595 14.1844 15.0047 14 15.4688 14C15.9329 14 16.378 14.1844 16.7062 14.5126C17.0344 14.8408 17.2188 15.2859 17.2188 15.75Z"
        stroke={stroke}
        strokeWidth="1.5"
      />
    </svg>
  );
}

export default PromotionAndMarketing;
